import { render, staticRenderFns } from "./Chips.vue?vue&type=template&id=d9cfacb4&scoped=true"
import script from "./Chips.vue?vue&type=script&lang=js"
export * from "./Chips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cfacb4",
  null
  
)

export default component.exports